import products from './products'
import auth from './auth'
import user from './user'
import test from './test'
import company from './company'

export default {
	products,
	auth,
	user,
	test,
	company
}



// WEBPACK FOOTER //
// ./src/vuex/api/services/index.js